/* eslint-disable jsx-a11y/no-onchange */
import React from 'react';
import PropTypes from 'prop-types';

export const SelectComponent = ({ label, name, value, onChange, error, errorMessage, disabled, children, required, ...rest }) => (
    <label className="nmx-form__input">
      {label}{required && <span>&#42;</span>}
      <select
        value={value}
        name={name}
        disabled={disabled}
        onChange={onChange}
        aria-required={required}
        {...rest}>
        {children}
      </select>
      {error && <small className='nmx-form__validation-error'>{errorMessage || 'Error'}</small>}
    </label>
);

SelectComponent.propTypes = {
  /** The label placed on the text field */
  label: PropTypes.string.isRequired,
  /** Name applied to input or textarea */
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  /** Is this input in an error state */
  error: PropTypes.bool,
  /** Message to display when error is true */
  errorMessage: PropTypes.string,
  /** The <option />'s for the select component */
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

SelectComponent.defaultProps = {
  value: '',
  onChange: () => {},
  disabled: false,
  error: false,
  errorMessage: 'Error',
  children: '',
  required: false,
};

export default SelectComponent;
